import { getSite } from '@/libs/plugins/contentful'
import router from '@/router'

const debug = process.env.VUE_APP_ENV !== 'production'

export default {

  state: {
    host: window.location.hostname,
    siteLoaded: false,
    site: {}
  },

  getters: {
    getBrandName (state, getters) {
      return getters.getSite &&
             getters.getSite.brandName;
    },
    getMetaDescription (state, getters) {
      return getters.getSite &&
             getters.getSite.metaDescription;
    },
    getMetaTitle (state, getters) {
      return getters.getSite &&
             getters.getSite.metaTitle;
    },
    getSite (state) {
      return state.site;
    },
    getTerms (state, getters) {
      return getters.getSite &&
             getters.getSite.termsPage;
    },
    getTermsContent (state, getters) {
      return getters.getTerms &&
             getters.getTerms.fields &&
             getters.getTerms.fields.termsContent;
    },
    getTermsTitle (state, getters) {
      return getters.getTerms &&
             getters.getTerms.fields &&
             getters.getTerms.fields.headerText;
    },
  },

  mutations: {
    setSite (state, { site }) {
      state.site = site;
      state.siteLoaded = !!site;
    }
  },

  actions: {
    async initApp ({ dispatch, commit, state }) {
      const previewHost = router.app._route.query.preview
      let host = debug && previewHost || state.host
      if (host.includes('www.')) host = host.slice(4, host.length);
      if (debug) {
        console.log(`Is Dev: ${debug}`);
        console.log(`Preview: ${previewHost || 'none'}`)
      }
      try {
        const contentfulSite = await getSite(host);
        const site = { ...contentfulSite.site };
        const cookieData = {
            enabled: contentfulSite.site.cookieBannerEnabled !== 'undefined'
              ? contentfulSite.site.cookieBannerEnabled
              : true,
            text: contentfulSite.site.cookieBannerText || '',
            buttonText: contentfulSite.site.cookieBannerButtonText || ''
        };

        delete site.cookieBannerEnabled;
        delete site.cookieBannerText;
        delete site.cookieBannerButtonText;

        commit('setSite', { site });
        commit('ui/setTheme', { theme: contentfulSite.theme });
        commit('ui/setCookieBanner', cookieData);
        if (!contentfulSite.site.oatEnabled) {
          dispatch('iOrderCore/showError', { heading: 'Oops, sorry about that!', message: 'Order at Table isn’t available at this time, please go to the bar to order. (code:killswitch)'})
        }
      } catch (e) {
        console.log('error', e);
        commit('setSite', Promise.resolve({ site: {}}));
        commit('ui/setTheme', { theme: {} });
      }
    },
    clearState ({ commit, state }) {
      commit('iOrderCore/initJourney');
    },
    checkNecessaryDataToProceed ({ state, getters, dispatch }) {
      const menus = getters['iOrderCore/getMenus'];
      const menusPopulated = Object.values(menus).length && Object.values(menus).reduce((bool, menu) => bool && !!menu.display.displayGroups.length, true);
      const sitePopulated = !!Object.keys(getters['getSite']).length;
      const themePopulated = !!Object.keys(getters['ui/getTheme']).length;
      const necessaryData = menusPopulated &&
                            sitePopulated &&
                            themePopulated &&
                            getters['iOrderCore/gotAllRequiredSalesData'];
      if (!necessaryData) router.push('/');
    },
  },

}
